export const selectedChipSx = {
  backgroundColor: 'info.main',
  borderColor: 'info.main',
  '& .MuiChip-label': { color: 'white', fontWeight: 600 },
  '&&:hover': { backgroundColor: 'info.main', borderColor: 'info.main' }
};



// WEBPACK FOOTER //
// ./src/vp-ui/dialogs/VpMediaSubmissionDetailsDialog/captionStyles.js